import { render } from "./InvoiceByYearView.vue?vue&type=template&id=24388454&ts=true"
import script from "./InvoiceByYearView.vue?vue&type=script&lang=ts"
export * from "./InvoiceByYearView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__